/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteSolutionViolationDtoBase
 * auto generated base class for the model RouteSolutionViolationDtoModel.
 */
export const RouteSolutionViolationDtoModelBase = ModelBase
  .named('RouteSolutionViolationDto')
  .props({
    __typename: types.optional(types.literal("RouteSolutionViolationDto"), "RouteSolutionViolationDto"),
    id: types.identifier,
    routeSolutionId: types.union(types.undefined, types.integer),
    type: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.null, types.string),
    value: types.union(types.undefined, types.number),
    createdOn: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteSolutionViolationDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeSolutionId() { return this.__attr(`routeSolutionId`) }
  get type() { return this.__attr(`type`) }
  get name() { return this.__attr(`name`) }
  get value() { return this.__attr(`value`) }
  get createdOn() { return this.__attr(`createdOn`) }
}
export function selectFromRouteSolutionViolationDto() {
  return new RouteSolutionViolationDtoModelSelector()
}

export const routeSolutionViolationDtoModelPrimitives = selectFromRouteSolutionViolationDto().routeSolutionId.type.name.value.createdOn
